





























import { Vue, Prop, Component } from 'vue-property-decorator'
import Chart from '@/components/Chart/index.vue'
@Component({
  name: 'MainTitle',
  components: { Chart }
})
export default class extends Vue {
  @Prop({ default: '#00B66C' }) private color!: string
  @Prop({ default: '#E9E9E9' }) private standardColor!: string
  @Prop({ default: '#979797' }) private standardBorderColor!: string

  @Prop({ default: '#A35DFF' }) private differenceColor!: string
  @Prop({ default: '#00B66C' }) private valueColor!: string

  @Prop() private normScore!: any
  @Prop() private avgScore!: any
  @Prop() private name!: any

  private chartId: string = ''
  created() {
    this.chartId = new Date().getTime() + '_' + parseInt(Math.random() * 10000000 + '')
  }
  private option: any = {
    grid: {
      left: 50,
      right: 20,
      top: 50,
      bottom: 50
    },
    xAxis: {
      type: 'category',
      data: ['参考标准', '', this.name],
      splitLine: {
        show: false
      },
      axisLine: {
        show: false
      },
      axisTick: {
        show: false
      },
      axisLabel: {
        color: '#666666'
      }
    },
    yAxis: {
      type: 'value',
      splitLine: {
        show: false
      },
      axisTick: {
        show: false
      },
      axisLine: {
        show: false
      },
      axisLabel: {
        color: '#999999'
      }
    },
    animation: false,
    series: [{
      stack: '总量',
      barWidth: 22,
      data: [{
        value: 0,
        itemStyle: {
          color: '#FFFFFF'
        }
      }, {
        value: Math.min(this.normScore, this.avgScore),
        itemStyle: {
          color: '#FFFFFF'
        }
      }, {
        value: 0,
        itemStyle: {
          color: '#FFFFFF'
        }
      }],
      markLine: {
        symbol: 'none',
        lineStyle: {
          type: 'dotted',
          color: '#979797'
        },
        data: [
          [{
            coord: ['参考标准', this.normScore]
          },
          {
            coord: ['', this.normScore]
          }
          ],
          [{
            coord: [this.name, this.avgScore]
          },
          {
            coord: ['', this.avgScore]
          }
          ]
        ]
      },
      type: 'bar',
      z: 9
    },
    {
      z: 10,
      stack: '总量',
      barWidth: 22,
      data: [{
        value: this.normScore,
        itemStyle: {
          color: this.standardColor,
          borderColor: this.standardBorderColor,
          borderType: 'dotted'
        },
        label: {
          show: true,
          color: '#666666',
          position: 'top'
        }
      }, {
        value: Math.abs((this.normScore - this.avgScore).toFixed(2)),
        itemStyle: {
          color: this.differenceColor
        },
        label: {
          show: true,
          color: '#A35DFF',
          position: 'top',
          formatter: (v) => {
            if (this.avgScore > this.normScore) {
              return `${v.value}`
            } else {
              return `-${v.value}`
            }
          }
        }
      }, {
        value: this.avgScore,
        itemStyle: {
          color: this.valueColor
        },
        label: {
          show: true,
          color: '#00B66C',
          position: 'top'
        }
      }],
      type: 'bar'
    }
    ]
  }
}
